/**
 *
 */

type MarketingData = {
  utmSource?: string;
  utmCampaign?: string;
  utmMedium?: string;
  coupon?: string;
};

const FixMarketingDataByUtmSource = async () => {
  const props = window.storeTheme.helpers.url.getJsonFromUrl(window.location.href);
  const marketingData = {} as MarketingData;

  if (props?.utm_source) {
    marketingData.utmSource = props.utm_source;
  }

  if (props?.utm_campaign) {
    marketingData.utmCampaign = props.utm_campaign;
  }

  if (props?.utm_medium) {
    marketingData.utmMedium = props.utm_medium;
  }

  if (props?.coupon) {
    marketingData.coupon = props.coupon;
  }

  if (Object.keys(marketingData).length && window.vtexjs) {
    let oderForm = window.vtexjs?.checkout?.orderForm;
    if (!oderForm) {
      oderForm = await window.vtexjs.checkout.getOrderForm();
    }

    return await window.vtexjs.checkout.sendAttachment('marketingData', {
      ...(oderForm?.marketingData ?? {}),
      ...marketingData,
    });
  }

  return;
};

window.storeTheme = window.storeTheme || ({} as StoreTheme);

Object.assign(window.storeTheme, {
  helpers: Object.assign(window.storeTheme.helpers || {}, { FixMarketingDataByUtmSource }),
});

export default {};
